import { fetchAllergensData } from '../actions/routines';

const initialState = {
    data: [],
    total: 0,
    loading: true,
    error: null,
};

const allergens = (state = initialState, action) => {
    switch (action.type) {
        case fetchAllergensData.TRIGGER:
            return {
                ...state,
                loading: true,
            };
        case fetchAllergensData.SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                total: action.payload.total
            };
        case fetchAllergensData.FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case fetchAllergensData.FULFILL:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default allergens;
